import { IScheduledJobConfiguration } from 'src/interfaces/ScheduledJobConfiguration';
import { ITenantMemberUser } from 'src/interfaces/TenantMember';

export const getInactiveUserIds = (users: ITenantMemberUser[] = []): Set<string> =>
	new Set(users.filter((user) => user.active === false).map((user) => user.id));

/**
 * Turning the switch off keeps the saved schedule, marked inactive, so its days, time and
 * recipients survive. Sending no schedule deletes it. Unsaved edits are dropped, so an
 * incomplete draft (e.g. a weekly schedule without days) is never sent.
 *
 * prod-mon rejects deactivated recipients even on an inactive schedule, and the recipients
 * field is hidden while the switch is off, so known-deactivated users are dropped. Users
 * removed from the tenant entirely are not in the users list and are still rejected.
 */
export const toDraftScheduledJobConfiguration = (
	config: IScheduledJobConfiguration,
	savedConfig?: IScheduledJobConfiguration,
	inactiveUserIds: ReadonlySet<string> = new Set()
): IScheduledJobConfiguration | undefined => {
	if (config.active) {
		return config;
	}
	if (!savedConfig) {
		return undefined;
	}
	const { emailRecipientUserIds } = savedConfig;
	return {
		...savedConfig,
		active: false,
		...(emailRecipientUserIds && {
			emailRecipientUserIds: emailRecipientUserIds.filter((id) => !inactiveUserIds.has(id))
		})
	};
};
